import { ICustomerConversionItem } from '@/models/customer-conversion';
import { IQueryPaginationOptions, Pagination } from '@/models/general';
import APIService from '../api';

class CustomersService extends APIService {
  constructor() {
    super();
  }

  get resource() {
    return `/admin/customer/participating?`;
  }

  getCustomerConversion(params: Partial<IQueryPaginationOptions>) {
    return this.getQueryPagination<ICustomerConversionItem[]>(
      '/admin/customer/conversion',
      params
    );
  }

  getCustomers({
    sortField,
    sortOrder = '',
    pagination = '',
    filters
  }: IQueryPaginationOptions) {
    const resource = this.generateResource(
      this.resource,
      sortField,
      sortOrder,
      pagination,
      filters
    );
    return this.get(resource);
  }

  getCustomerByName(name: string) {
    const url = `${this.resource}&name=${name}`;
    return this.get(url);
  }

  getActivity(id: string) {
    return this.get(`/activity/${id}`);
  }
}
export default CustomersService;
